/**
 * AuthHeading — title + lighter subtitle at the top of every auth form.
 *
 * Sits on the system surface (Option A split shell), so it uses ink
 * tokens and the UI font: Poppins in English, Cairo in Arabic via the
 * global html[lang="ar"] rule. Start-aligned by default to match the
 * form's reading edge.
 */

export default function AuthHeading({ title, subtitle, align = 'start', className = '' }) {
  const alignCls = align === 'center' ? 'text-center' : 'text-start'
  return (
    <div className={`${alignCls} mb-8 ${className}`}>
      <h1 className="text-2xl sm:text-[1.75rem] font-semibold text-ink-primary leading-tight">
        {title}
      </h1>
      {subtitle && (
        <p className="mt-2 text-sm text-ink-secondary leading-relaxed">
          {subtitle}
        </p>
      )}
    </div>
  )
}
